import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Gifts() {
  const [ref, setRef] = useState(null);
  useEffect(() => { api.get("/reference").then((r) => setRef(r.data)); }, []);
  if (!ref) return null;
  return (
    <div className="fade-up">
      <p className="eyebrow">Reference</p>
      <h1 className="font-display text-navy text-4xl font-semibold tracking-tight mt-2">Gifts & personality</h1>
      <p className="text-muted-ink mt-2 max-w-2xl">The 24 spiritual gifts and four DISC styles volunteers are measured on.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
        {ref.disc.map((d) => (
          <div key={d.key} className="bg-navy text-white rounded-2xl p-7 lift" data-testid={`disc-card-${d.key}`}>
            <span className="font-display text-5xl font-bold text-[#8FD3C6]">{d.key}</span>
            <p className="font-display text-lg font-semibold mt-2">{d.name}</p>
            <p className="text-white/70 text-sm mt-2 leading-relaxed">{d.summary}</p>
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {ref.gifts.map((g) => (
          <div key={g.key} className="card-soft p-6" data-testid={`gift-card-${g.key}`}>
            <p className="font-display text-navy font-semibold">{g.name}</p>
            <p className="text-muted-ink text-sm mt-2 leading-relaxed">{g.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
